import { FolderStatusEnum } from '@koob/enums';
import { getSetting, getSettingLabel, getTripStatus } from '@koob/utils';

// Kept as a fallback for diaries generated before the titles were seeded in
// the travel diary dictionary.
const STATUS_TITLES = {
  [FolderStatusEnum.DRAFT]: 'Draft itinerary',
  [FolderStatusEnum.CONFIRMING]: 'Booking in progress',
  [FolderStatusEnum.CONFIRMED]: 'Booking confirmed',
  [FolderStatusEnum.CANCELLED]: 'Booking cancelled',
};

export default function ExportFooterStatus({ trip, settings }) {
  const status = getTripStatus(trip);

  const footerSection = getSetting(settings, 'footer');
  const statusSubsection = getSetting(
    footerSection?.sections,
    `status-${status}`,
  );
  // `||`, not `??`: a dictionary entry cleared in the UI reaches us as an empty
  // string, and that must fall back to the system wording rather than blank the
  // whole block through the `!title` guard below.
  const title =
    getSettingLabel(statusSubsection?.fields, `status-${status}-title`) ||
    STATUS_TITLES[status];
  if (!title) return null;

  const message = getSettingLabel(
    statusSubsection?.fields,
    `status-${status}-message`,
  );

  return (
    <div className="max-w-md min-w-0">
      <div className="text-2xs font-bold uppercase tracking-widest text-[var(--td-primary)]">
        {title}
      </div>
      {message && (
        <div className="mt-0.5 text-2xs leading-snug text-[var(--td-ink-muted)]">
          {message}
        </div>
      )}
    </div>
  );
}
